export default {
    carregando: false,
    items: [],
    tipoAgings: [],
    macroProcessos: [],
    processosHierarquias: [],
    selecionado: {}
}